const encoder = new TextEncoder();
/** Mongo simple collation compares UTF-8 bytes, including non-ASCII IDs. */
export function compareTimeListIds(a: string, b: string): number {
    const left = encoder.encode(a);
    const right = encoder.encode(b);
    for (let i = 0; i < Math.min(left.length, right.length); i++) {
        if (left[i] !== right[i]) return left[i]! - right[i]!;
    }
    return left.length - right.length;
}
